<template>

    <div class="one-and-four" ref="oneAndFourContainer">

        <!--Left side-->
        <div class="one-and-four__primary">

            <div class="ag-video-slides">
                <v-slick-carousel v-bind="sliderSettings" ref="carousel">
                    <div class="ag-video-slide" v-for="(cta, index) in displayModel.ctas">

                        <!--Background image-->
                        <div class="ag-background-image">
                            <img :src="cta.imageUrl" />
                        </div>

                        <!--Slide overlay-->
                        <div class="one-and-four__primary-container" ref="slideOverlayContainers">
                            <div>
                                <div class="h-xl h-xl-alt  u-font-aeonik-bold">{{ cta.title }}</div>
                                <p class="u-font-noto-sans">
                                    {{ cta.subTitle }}
                                </p>

                                <!--CTA-->
                                <p class="u-font-aeonik-bold u-color-white">
                                    <template v-if="cta.destinationPageUrl">
                                        <a :href="cta.destinationPageUrl" class="action"
                                            :target="cta.destinationPageUrl.startsWith('#') ? null : '_blank'">
                                            <span class="cta">{{ cta.ctaText }}</span>
                                        </a>
                                    </template>
                                    <template v-else-if="cta.bynderVideo || cta.youtubeId">
                                        <a href="#" @click.prevent="openModal(cta)" class="action">
                                            <span class="cta">{{ cta.ctaText }}</span>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <span class="cta">Fallback</span>
                                    </template>
                                </p>

                            </div>
                        </div>

                    </div>
                </v-slick-carousel>

                <!--Slider manual controls-->
                <div class="one-and-four__nav">
                    <button @click="carousel.prev()" type="button" class="slick-prev">
                        <svg preserveAspectRatio="xMidYMid meet" role="img" viewBox="0 0 32 32" aria-label=" icon"
                            class="icon" alt="Previous Slide">
                            <use xlink:href="#icon-chevron-left"></use>
                        </svg>
                    </button>

                    <button @click="carousel.next()" type='button' class='slick-next'>
                        <svg preserveAspectRatio="xMidYMid meet" role="img" viewBox="0 0 32 32" aria-label=" icon"
                            class="icon" alt="Next Slide">
                            <use xlink:href="#icon-chevron-right"></use>
                        </svg>
                    </button>
                </div>
            </div>

        </div>

        <!--Right side-->
        <div class="one-and-four__column u-bg-color-off-white" ref="linkBar">
            <!--Right heading-->
            <div class="u-padd-top u-padd-sides">
                <div class="u-font-aeonik-bold u-txt-uppercase u-padd-sides-half">
                    <strong>{{ displayModel.topCtaLabel }}</strong>
                </div>
            </div>

            <!--Promo links-->
            <div class="cursor-pointer" v-for="(promo, index) in displayModel.rightSidePromos">
                <h3 class="h-md u-font-aeonik-light u-mrg-top-half u-mrg-btm-qtr">{{ promo.title }}</h3>
                <p>
                    <a :href="promo.destinationPageUrl" class="cta u-font-aeonik-bold" :target="promo.destinationPageUrl.startsWith('#') ? null : '_blank'">
                        <strong>{{ promo.ctaText }}</strong>
                    </a>
                </p>
            </div>
        </div>



    </div>

    <video-dialog ref="dialog" v-bind="dialogCta"></video-dialog>
</template>

<script setup>
import { ref, onMounted, reactive, nextTick, onUnmounted } from 'vue'
import { VSlickCarousel } from 'v-slick-carousel'
import VideoDialog from './components/VideoDialog.vue'

const carousel = ref(null)
const oneAndFourContainer = ref(null)
const slideOverlayContainers = ref([])
const linkBar = ref(null)
const dialog = ref(null)

const dialogCta = ref({})

const sliderSettings = reactive({
    widthDetection: 'auto',
    arrows: false
})

defineProps({
    displayModel: Object,
    default: {
        topCtaLabel: "Undefined",
        ctas: []
    }
})


onMounted(async () => {
    console.log("AgHeroIsland mounted");


    //manage slide height
    await nextTick()
    updateSlideHeight();
    window.addEventListener('resize', updateSlideHeight)
})

onUnmounted(() => {
    window.removeEventListener('resize', updateSlideHeight)
})


//update the slide containers to the min height of the sidebar if we are on a 
//screen size that accomodates both side by side
function updateSlideHeight() {
    if (linkBar.value && slideOverlayContainers.value) {
        const containerHeight = linkBar.value.offsetHeight;
        slideOverlayContainers.value.forEach(el => {
            el.style.minHeight = window.innerWidth >= 768 ? `${containerHeight}px` : null;
        })
    }
}

async function openModal(cta) {
    dialogCta.value = {
        title: cta.title,
        showTitle: true,
        modalContent: cta.promoHtml
    }

    //show only one of the videos defined in the cta, and don't open if not
    if (cta.youtubeId) {
        dialogCta.value.youtubeId = cta.youtubeId
    } else if (cta.bynderVideo) {
        dialogCta.value.videoSrc = cta.bynderVideo
    } else {
        return;
    }

    dialog.value.open()
}





</script>